'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// lib
import Box, { BoxProps } from '../box'
import HeaderTitle from './header-title'

/* -----------------------------------------------------------------------------
 * Header
 * -------------------------------------------------------------------------- */

export type HeaderProps = BoxProps & {
  headerTitle?: React.ReactNode
  headerLeft?: React.ReactNode
  headerRight?: React.ReactNode
  title?: string
}

function Header({
  headerTitle,
  headerLeft,
  headerRight,
  title,
  ...rest
}: HeaderProps) {
  return (
    <Box
      height={50}
      flexDirection='row'
      alignItems='center'
      borderColor='shade03'
      borderBottomWidth={1}
      {...rest}
    >
      <Box
        flex='1 1 auto'
        width='50%'
        flexDirection='row'
        justifyContent='flex-start'
      >
        {headerLeft}
      </Box>
      <Box flex='1 0 auto' flexDirection='row'>
        {headerTitle || <HeaderTitle>{title}</HeaderTitle>}
      </Box>
      <Box
        flex='1 1 auto'
        width='50%'
        flexDirection='row'
        justifyContent='flex-end'
      >
        {headerRight}
      </Box>
    </Box>
  )
}

export default Header
